import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { calcResize } from 'components/Layout/styles';
import { mediaBreakpointDown, mediaBreakpointUp } from 'utils/styledCssHelpers';

export const STextCard = styled.div`
  height: auto;
  max-width: 430px;
  //border: 1px solid red;
  overflow: hidden;
  margin: ${props =>
    props.align
      ? (props.align === 'right' && '30px 0 30px auto') ||
        (props.align === 'left' && '30px auto 30px 0')
      : props.align === 'center' && '30px auto'};

  @media only screen and (max-width: 992px) {
    margin: 0 auto;
  }
`;

export const SCircle = styled.div`
  background-color: ${props => props.theme.colors.accent};
  border-radius: 50px;
  height: 50px;
  width: 50px;
  justify-content: center;
  align-items: center;
  margin: 0 10px;

  p {
    font-size: 27px;
    color: white;
    text-align: center;
    margin-top: 5px;
  }
`;

export const SNumber = styled.div`
  margin: 0 auto;
`;

export const STitle = styled.div`
  color: #192f54;
  font-size: ${calcResize(50, 60)};
`;

export const SHeader = styled.div.attrs({
  className: 'justify-content-center justify-content-lg-start',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SDescription = styled.div`
  color: #0d263b;
  font-size: ${calcResize(15, 20)};
`;
